/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import { observer, inject } from "mobx-react";
// UI Framework
import { Menu, Avatar, Modal, Icon, Spin } from "antd";
// Shared components
import CreditAmount from "../CreditAmount";
import Dropdown from "components/Dropdown";
import { push } from "helpers/history";
// Hooks and utilities
import { get } from "lodash";
import useUser from "hooks/useUser";
import UserStore from "state/user";
//styles
import styles from "./index.module.scss";

const { confirm } = Modal;

interface IProps {
	user?: UserStore;
}
const DropDown: React.FC<IProps> = props => {
	const { logout } = useUser();

	function logoutUser() {
		confirm({
			title: "خروج از حساب کاربری",
			content: "آیا برای خروج از حساب کاربری خود اطمینان دارید؟",
			onOk() {
				logout();
			},
		});
	}

	const menu = (
		<Menu>
			<Menu.Item key="0">
				<span onClick={() => push("/dashboard/profile")}>
					<Icon type="setting" />
					پروفایل کاربری
				</span>
			</Menu.Item>
			{!get(props.user, ["aanLogin"]) && (
				<Menu.Item key="1">
					<span onClick={() => push("/dashboard/change-password")}>
						<Icon type="lock" />
						تغییر رمز عبور
					</span>
				</Menu.Item>
			)}
			{!get(props.user, ["aanLogin"]) && <Menu.Divider />}
			{!get(props.user, ["aanLogin"]) && (
				<Menu.Item key="3" className={styles["logout"]}>
					<span onClick={logoutUser} className={styles["logout__text"]}>
						<Icon type="poweroff" />
						خروج از حساب کاربری
					</span>
				</Menu.Item>
			)}
		</Menu>
	);
	const fullName = `${get(props.user, ["user", "profile", "firstname"])} ${get(props.user, [
		"user",
		"profile",
		"lastname",
	])}`;
	return (
		<div className={styles["dropdown"]}>
			{get(props.user, ["loading"]) ? (
				<Spin style={{ position: "absolute", left: 50, top: 10 }} />
			) : (
				<>
					<CreditAmount />
					<Dropdown overlay={menu} trigger={["click"]}>
						<span>
							<Avatar src={get(props.user, ["profileImage"])} />
							<span className={styles["dropdown__user-fullname"]} title={fullName}>
								{fullName}
							</span>
						</span>
					</Dropdown>
				</>
			)}
		</div>
	);
};

export default inject("user")(observer(DropDown));
